import { useState } from 'react';
import { type TranscriptMsg, when } from '../../lib/n4';
import { Markdown } from './Markdown';

// Olvasható beszélgetés (a CLI átiratából): a felhasználó üzenetei, az ügynök válaszai, a rendszer üzenetei halványan;
// az eszközhívások rejtve, számmal (kérésre kibontva). Az Olvasható fül és a munkás-napló is ezt használja.
export function MessageList({ msgs, who = 'Ügynök' }: { msgs: TranscriptMsg[]; who?: string }) {
  const [openTools, setOpenTools] = useState<Set<number>>(new Set());
  return (
    <>
      {msgs.map((m, i) => m.role === 'system' ? (
        <div key={i} className="mb-2 px-3 py-1 text-[11px] text-neutral-500"><span className="mr-2 text-neutral-600">{when(m.at)} · rendszer</span><span className="whitespace-pre-wrap">{m.text.length > 400 ? `${m.text.slice(0, 400)}…` : m.text}</span></div>
      ) : (
        <div key={i} className={`mb-3 rounded-lg px-3 py-2 ${m.role === 'user' ? 'border border-[var(--color-accent)]/30 bg-[var(--color-accent)]/5' : 'bg-black/30'}`}>
          <div className="mb-1 flex items-center gap-2 text-[11px] text-neutral-500"><span className={m.role === 'user' ? 'text-[var(--color-accent)]' : 'text-neutral-300'}>{m.role === 'user' ? 'Te' : who}</span><span>{when(m.at)}</span>{m.images ? <span>· {m.images} kép</span> : null}
            {m.tools && m.tools.length > 0 && <button className="ml-auto text-neutral-600 hover:text-neutral-300" onClick={() => setOpenTools((o) => { const n = new Set(o); if (n.has(i)) n.delete(i); else n.add(i); return n; })}>{m.tools.length} eszközhívás {openTools.has(i) ? '▲' : '▼'}</button>}</div>
          {m.text ? <Markdown text={m.text} /> : <span className="text-xs text-neutral-600">(csak eszközhívások, szöveg nélkül)</span>}
          {m.tools && m.tools.length > 0 && openTools.has(i) && (
            <div className="mt-2 flex flex-wrap gap-1">
              {m.tools.map((t, j) => <span key={j} className="rounded bg-black/50 px-1.5 py-0.5 font-mono text-[11px] text-neutral-400" title={t.arg}>{t.name}{t.arg ? ` · ${t.arg.slice(0, 50)}` : ''}</span>)}
            </div>
          )}
        </div>
      ))}
    </>
  );
}
